import qs from 'qs';
import _ from 'lodash';
import { apiGet, apiPost, apiPut } from "./helper/ApiHelper";

export const FETCHING_USER_PROFILE = 'FETCHING_USER_PROFILE';
export const USER_PROFILE_FETCHED = 'USER_PROFILE_FETCHED';
export const ERROR_FETCHING_USER_PROFILE = 'ERROR_FETCHING_USER_PROFILE';
export const SET_AI_ANALYST_NO_REMAINING_QUESTIONS = 'SET_AI_ANALYST_NO_REMAINING_QUESTIONS';
export const SET_LAST_MESSAGE_TIMESTAMP = 'SET_LAST_MESSAGE_TIMESTAMP';

export function fetchUserProfile(response) {
  return {
    type: USER_PROFILE_FETCHED,
    userProfile: response
  }
}

export const handleFetchUserProfile = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_USER_PROFILE
      });
      const response = await apiGet('/v1/user/users', session, params, cancelToken);
      dispatch(fetchUserProfile(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_USER_PROFILE,
        userProfile: {
          status: 'error',
          message: 'Error fetching User profile'
        }
      });
    }
  };
}

export const SENDING_CONTACT_REP_EMAIL = 'SENDING_CONTACT_REP_EMAIL';
export const CONTACT_REP_EMAIL_SENT = 'CONTACT_REP_EMAIL_SENT';
export const ERROR_SENDING_CONTACT_REP_EMAIL = 'ERROR_SENDING_CONTACT_REP_EMAIL';

export function sendContactRepEmail(response) {
  return {
    type: CONTACT_REP_EMAIL_SENT,
    contactRepEmailSent: response
  }
}

export const handleContactRepEmail = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: SENDING_CONTACT_REP_EMAIL
      });

      const response = await apiPost('/v1/user/users/send_contact_rep_email',
        qs.stringify({ email: _.isEmpty(params) ? {} : JSON.stringify(params) }),
        session,
        cancelToken,
        {
          'Content-Type': 'multipart/form-data',
          'X-User-Email': session.email,
          'X-User-Token': session.token,
          'X-User-Admin-Log-Token': session.admin_auth_token,
        });

      dispatch(sendContactRepEmail(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_SENDING_CONTACT_REP_EMAIL,
        contactRepEmailSent: {
          status: 'error',
          message: 'Error sending Conctact Rep email'
        }
      });
    }
  };
}

export const UPDATING_USER = 'UPDATING_USER';
export const USER_UPDATED = 'USER_UPDATED';
export const USER_UPDATED_SERVER_VERSION = 'USER_UPDATED_SERVER_VERSION';
export const USER_UPDATED_NETWORK_ENABLED = 'USER_UPDATED_NETWORK_ENABLED';
export const USER_UPDATED_PERMISSIONS = 'USER_UPDATED_PERMISSIONS';
export const USER_UPDATED_INTEGRATIONS = 'USER_UPDATED_INTEGRATIONS';
export const USER_UPDATED_CUSTOM_FILTERS = 'USER_UPDATED_CUSTOM_FILTERS';
export const USER_UPDATED_BT_CUSTOM_FILTERS = 'USER_UPDATED_BT_CUSTOM_FILTERS';
export const USER_UPDATED_DEFAULT_SEARCH = 'USER_UPDATED_DEFAULT_SEARCH';
export const ERROR_UPDATING_USER = 'ERROR_UPDATING_USER';

// Updates a single default-search field on the session (e.g. default_ria_search,
// default_bt_search) immediately, so toggling a saved filter's "Default" flag takes
// effect on the next visit without waiting for the async health_check refresh.
export const userUpdatedDefaultSearch = (field, value) => ({
  type: USER_UPDATED_DEFAULT_SEARCH,
  field,
  value,
});
export const TEAMMATES_FIRST_LOAD = 'TEAMMATES_FIRST_LOAD';
export const NOTE_TYPES_FIRST_LOAD = 'NOTE_TYPES_FIRST_LOAD';

export function updateUserData(response) {
  return {
    type: USER_UPDATED,
    userSession: response
  }
}

export const handleUpdateUserData = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_USER
      });

      let data;

      if (params.photo != undefined) {
        data = new FormData();
        data.append('user[photo]', params.photo);
      } else {
        data = qs.stringify({ user: _.isEmpty(params) ? {} : JSON.stringify(params) });
      }
      const response = await apiPut(
        `/v1/user/users`,
        data,
        session,
        cancelToken,
        {
          'Content-Type': 'multipart/form-data',
          'X-User-Email': session.email,
          'X-User-Token': session.token,
          'X-User-Admin-Log-Token': session.admin_auth_token,
        });

      dispatch(updateUserData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_USER,
        userSession: {
          status: 'error',
          message: 'Error updating user data'
        }
      });
    }
  };
}

export const FETCHING_TIME_ZONES = 'FETCHING_TIME_ZONES';
export const TIME_ZONES_FETCHED = 'TIME_ZONES_FETCHED';
export const ERROR_FETCHING_TIME_ZONES = 'ERROR_FETCHING_TIME_ZONES';

export function fetchTimeZones(response) {
  return {
    type: TIME_ZONES_FETCHED,
    timeZones: response
  }
}

export const handleFetchTimeZones = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_TIME_ZONES
      });
      const response = await apiGet('/v1/user/users/time_zones', session, params, cancelToken);
      dispatch(fetchTimeZones(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_TIME_ZONES,
        timeZones: {
          status: 'error',
          message: 'Error fetching time zones'
        }
      });
    }
  };
}

export const FETCHING_SHARE_PERMISSIONS_SETTINGS = 'FETCHING_SHARE_PERMISSIONS_SETTINGS';
export const SHARE_PERMISSIONS_SETTINGS_FETCHED = 'SHARE_PERMISSIONS_SETTINGS_FETCHED';
export const ERROR_FETCHING_SHARE_PERMISSIONS_SETTINGS = 'ERROR_FETCHING_SHARE_PERMISSIONS_SETTINGS';

export function fetchSharePermissionsSettings(response) {
  return {
    type: SHARE_PERMISSIONS_SETTINGS_FETCHED,
    sharePermissionsSettings: response
  }
}

export const handleFetchSharePermissionsSettings = (session, cancelToken, permissionShareId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_SHARE_PERMISSIONS_SETTINGS
      });
      const response = await apiGet(`/v1/user/permission_shares/${permissionShareId}/user_permissions_shares`, session, params, cancelToken);

      dispatch(fetchSharePermissionsSettings(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_SHARE_PERMISSIONS_SETTINGS,
        sharePermissionsSettings: {
          status: 'error',
          message: 'Error fetching time zones'
        }
      });
    }
  };
}

export const FETCHING_SHARE_PERMISSIONS = 'FETCHING_SHARE_PERMISSIONS';
export const SHARE_PERMISSIONS_FETCHED = 'SHARE_PERMISSIONS_FETCHED';
export const ERROR_FETCHING_SHARE_PERMISSIONS = 'ERROR_FETCHING_SHARE_PERMISSIONS';

export function fetchSharePermissions(response) {
  return {
    type: SHARE_PERMISSIONS_FETCHED,
    sharePermissions: response
  }
}

export const handleFetchSharePermissions = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_SHARE_PERMISSIONS
      });

      const response = await apiGet('/v1/user/users/permission_shares', session, params, cancelToken);

      dispatch(fetchSharePermissions(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_SHARE_PERMISSIONS,
        sharePermissions: {
          status: 'error',
          message: 'Error fetching time zones'
        }
      });
    }
  };
}

export const handleUpdateSharePermissions = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      const response = await apiPut('/v1/user/users/update_permission_shares',
        qs.stringify({ permission_share: _.isEmpty(params) ? {} : JSON.stringify(params) }),
        session,
        cancelToken);

      dispatch(fetchSharePermissions(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_SHARE_PERMISSIONS,
        sharePermissions: {
          status: 'error',
          message: 'Error fetching time zones'
        }
      });
    }
  };
}

export const FETCHING_USER_AFFINITY_SETTINGS = 'FETCHING_USER_AFFINITY_SETTINGS';
export const USER_AFFINITY_SETTINGS_FETCHED = 'USER_AFFINITY_SETTINGS_FETCHED';
export const ERROR_FETCHING_USER_AFFINITY_SETTINGS = 'ERROR_FETCHING_USER_AFFINITY_SETTINGS';

export function fetchUserAffinitySettings(response) {
  return {
    type: USER_AFFINITY_SETTINGS_FETCHED,
    userAffinitySettings: response
  }
}

export const handleFetchUserAffinitySettings = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_USER_AFFINITY_SETTINGS
      });

      const response = await apiGet('/v1/user/users/affinity_settings', session, params, cancelToken);

      dispatch(fetchUserAffinitySettings(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_USER_AFFINITY_SETTINGS,
        userAffinitySettings: {
          status: 'error',
          message: 'Error fetching User affinity settings'
        }
      });
    }
  };
}

export const UPDATING_USER_AFFINITY_SETTINGS = 'UPDATING_USER_AFFINITY_SETTINGS';
export const USER_AFFINITY_SETTINGS_UPDATED = 'USER_AFFINITY_SETTINGS_UPDATED';
export const ERROR_UPDATING_USER_AFFINITY_SETTINGS = 'ERROR_UPDATING_USER_AFFINITY_SETTINGS';

export function updateUserAffinitySettings(response) {
  return {
    type: USER_AFFINITY_SETTINGS_UPDATED,
    userAffinitySettingsUpdated: response
  }
}

export const handleUpdateUserAffinitySettings = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_USER_AFFINITY_SETTINGS
      });
      const response = await apiPut(`/v1/user/users/update_affinity_settings`, qs.stringify({ user: _.isEmpty(params) ? {} : JSON.stringify(params) }), session, cancelToken, {
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      });

      dispatch(updateUserAffinitySettings(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_USER_AFFINITY_SETTINGS,
        userAffinitySettingsUpdated: {
          status: 'error',
          message: 'Error updating user affinity settings'
        }
      });
    }
  };
}


export const UPDATING_USER_PERMISSION_SHARE_SETTING = 'UPDATING_USER_PERMISSION_SHARE_SETTING';
export const USER_PERMISSION_SHARE_SETTING_UPDATED = 'USER_PERMISSION_SHARE_SETTING_UPDATED';
export const ERROR_UPDATING_USER_PERMISSION_SHARE_SETTING = 'ERROR_UPDATING_USER_PERMISSION_SHARE_SETTING';

export function updateUserPermissionShareSetting(response) {
  return {
    type: USER_PERMISSION_SHARE_SETTING_UPDATED,
    userPermissionShareSetting: response
  }
}

export const handleUpdateUserPermissionShareSetting = (session, cancelToken, userPermissionShareId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_USER_PERMISSION_SHARE_SETTING
      });
      const response = await apiPut(`/v1/user/user_permissions_shares/${userPermissionShareId}`,
        qs.stringify({ user_permissions_share: _.isEmpty(params) ? {} : JSON.stringify(params) }), session, cancelToken);

      dispatch(updateUserPermissionShareSetting(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_USER_PERMISSION_SHARE_SETTING,
        userPermissionShareSetting: {
          status: 'error',
          message: 'Error updating permission setting'
        }
      });
    }
  };
}

export const UPDATING_SHARE_PERMISSIONS_SETTINGS = 'UPDATING_SHARE_PERMISSIONS_SETTINGS';
export const SHARE_PERMISSIONS_SETTINGS_UPDATED = 'SHARE_PERMISSIONS_SETTINGS_UPDATED';
export const ERROR_UPDATING_SHARE_PERMISSIONS_SETTINGS = 'ERROR_UPDATING_SHARE_PERMISSIONS_SETTINGS';

export function updateSharePermissionsSettings(response) {
  return {
    type: SHARE_PERMISSIONS_SETTINGS_UPDATED,
    sharePermissionsSetting: response
  }
}

export const handleUpdateSharePermissionsSettings = (session, cancelToken, permissionShareId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_SHARE_PERMISSIONS_SETTINGS
      });
      const response = await apiPut(`/v1/user/permission_shares/${permissionShareId}`,
        qs.stringify({ permission_share: _.isEmpty(params) ? {} : JSON.stringify(params) }),
        session,
        cancelToken);

      dispatch(updateSharePermissionsSettings(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_SHARE_PERMISSIONS_SETTINGS,
        sharePermissionsSetting: {
          status: 'error',
          message: 'Error updating share permission'
        }
      });
    }
  };
}


export const FETCHING_USER_HIGHLIGHT_ENABLED = 'FETCHING_USER_HIGHLIGHT_ENABLED';
export const USER_HIGHLIGHT_ENABLED_FETCHED = 'USER_HIGHLIGHT_ENABLED_FETCHED';
export const ERROR_FETCHING_USER_HIGHLIGHT_ENABLED = 'ERROR_FETCHING_USER_HIGHLIGHT_ENABLED';

export function fetchUserHighlightEnabled(response) {
  return {
    type: USER_HIGHLIGHT_ENABLED_FETCHED,
    userHighlightEnabled: response
  }
}

export const handleFetchUserHighlightEnabled = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_USER_HIGHLIGHT_ENABLED
      });

      const response = await apiGet('/v1/user/users/user_highlight_enabled', session, {}, cancelToken);

      dispatch(fetchUserHighlightEnabled(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_USER_HIGHLIGHT_ENABLED,
        userHighlightEnabled: {
          status: 'error',
          message: 'Error fetching User highlight enabled'
        }
      });
    }
  };
}

export const UPDATING_USER_HIGHLIGHT_ENABLED = 'UPDATING_USER_HIGHLIGHT_ENABLED';
export const USER_HIGHLIGHT_ENABLED_UPDATED = 'USER_HIGHLIGHT_ENABLED_UPDATED';
export const ERROR_UPDATING_USER_HIGHLIGHT_ENABLED = 'ERROR_UPDATING_USER_HIGHLIGHT_ENABLED';

export function updateUserHighlightEnabled(response) {
  return {
    type: USER_HIGHLIGHT_ENABLED_UPDATED,
    userHighlightEnabled: response
  }
}

export const handleUpdateUserHighlightEnabled = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_USER_HIGHLIGHT_ENABLED
      });
      const response = await apiPut('/v1/user/users/update_highlight_enabled', qs.stringify({ user: _.isEmpty(params) ? {} : JSON.stringify(params) }), session, cancelToken);

      dispatch(updateUserHighlightEnabled(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_USER_HIGHLIGHT_ENABLED,
        userHighlightEnabled: {
          status: 'error',
          message: 'Error updating user highlight enabled'
        }
      });
    }
  };
}

export const FETCHING_USER_REMAINING_DOWNLOADS = 'FETCHING_USER_REMAINING_DOWNLOADS';
export const USER_REMAINING_DOWNLOADS_FETCHED = 'USER_REMAINING_DOWNLOADS_FETCHED';
export const ERROR_FETCHING_USER_REMAINING_DOWNLOADS = 'ERROR_FETCHING_USER_REMAINING_DOWNLOADS';

export function fetchUserRemainingDownloads(response) {
  return {
    type: USER_REMAINING_DOWNLOADS_FETCHED,
    userRemainingDownloads: response
  }
}

export const handleFetchUserRemainingDownloads = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_USER_REMAINING_DOWNLOADS
      });
      const response = await apiGet(`/v1/user/users/remaining_downloads`, session, {}, cancelToken)

      dispatch(fetchUserRemainingDownloads(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_USER_REMAINING_DOWNLOADS,
        userRemainingDownloads: {
          status: 'error',
          message: 'Error fetching User remaining downloads'
        }
      });
    }
  };
}


export const SENDING_EXTENDER_SEATS_EMAIL = 'SENDING_EXTENDER_SEATS_EMAIL';
export const EXTENDER_SEATS_EMAIL_SENT = 'EXTENDER_SEATS_EMAIL_SENT';
export const ERROR_SENDING_EXTENDER_SEATS_EMAIL = 'ERROR_SENDING_EXTENDER_SEATS_EMAIL';

export function sendExtenderSeatsEmail(response) {
  return {
    type: EXTENDER_SEATS_EMAIL_SENT,
    extenderSeatsEmail: response
  }
}

export const handleExtenderSeatsEmail = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: SENDING_EXTENDER_SEATS_EMAIL
      });

      const response = await apiPost('/v1/user/users/add_network_extender_seats',
        {},
        session,
        cancelToken,
        {
          'Content-Type': 'multipart/form-data',
          'X-User-Email': session.email,
          'X-User-Token': session.token,
          'X-User-Admin-Log-Token': session.admin_auth_token,
        })

      dispatch(sendExtenderSeatsEmail(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_SENDING_EXTENDER_SEATS_EMAIL,
        extenderSeatsEmail: {
          status: 'error',
          message: 'Error sending extender seats email'
        }
      });
    }
  };
}

export const FETCHING_CHAMELEON_DATA = 'FETCHING_CHAMELEON_DATA';
export const CHAMELEON_DATA_FETCHED = 'CHAMELEON_DATA_FETCHED';
export const ERROR_FETCHING_CHAMELEON_DATA = 'ERROR_FETCHING_CHAMELEON_DATA';

export function fetchUserChameleonData(response) {
  return {
    type: CHAMELEON_DATA_FETCHED,
    userChameleonData: response
  }
}

export const handleFetchUserChameleonData = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_CHAMELEON_DATA
      });

      const response = await apiGet('/v1/user/users/chameleon_data', session, {}, cancelToken);

      dispatch(fetchUserChameleonData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_CHAMELEON_DATA,
        userChameleonData: {
          status: 'error',
          message: 'Error fetching User chameleon data'
        }
      });
    }
  };
}

export const FETCHING_MIXPANEL_DATA = 'FETCHING_MIXPANEL_DATA';
export const MIXPANEL_DATA_FETCHED = 'MIXPANEL_DATA_FETCHED';
export const ERROR_FETCHING_MIXPANEL_DATA = 'ERROR_FETCHING_MIXPANEL_DATA';

export function fetchUserMixpanelData(response) {
  return {
    type: MIXPANEL_DATA_FETCHED,
    userMixpanelData: response
  }
}

export const handleFetchUserMixpanelData = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_MIXPANEL_DATA
      });

      const response = await apiGet('/v1/user/users/mixpanel_data', session, {}, cancelToken);

      dispatch(fetchUserMixpanelData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_MIXPANEL_DATA,
        userMixpanelData: {
          status: 'error',
          message: 'Error fetching User mixpanel data'
        }
      });
    }
  };
}

export const FETCHING_MIXPANEL_TOKEN = 'FETCHING_MIXPANEL_TOKEN';
export const MIXPANEL_TOKEN_FETCHED = 'MIXPANEL_TOKEN_FETCHED';
export const ERROR_FETCHING_MIXPANEL_TOKEN = 'ERROR_FETCHING_MIXPANEL_TOKEN';

export function fetchMixpanelToken(response) {
  return {
    type: MIXPANEL_TOKEN_FETCHED,
    mixpanelToken: response
  }
}

export const handleFetchMixpanelToken = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_MIXPANEL_TOKEN
      });

      const response = await apiGet('/v1/user/users/mixpanel_token', session, {}, cancelToken);

      dispatch(fetchMixpanelToken(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_MIXPANEL_TOKEN,
        mixpanelToken: {
          status: 'error',
          message: 'Error fetching mixpanel token'
        }
      });
    }
  };
}

export const REQUESTING_ADDITIONAL_DOSSIER_DOWNLOADS = 'REQUESTING_ADDITIONAL_DOSSIER_DOWNLOADS';
export const ADDITIONAL_DOSSIER_DOWNLOADS_REQUESTED = 'ADDITIONAL_DOSSIER_DOWNLOADS_REQUESTED';
export const ERROR_REQUESTING_ADDITIONAL_DOSSIER_DOWNLOADS = 'ERROR_REQUESTING_ADDITIONAL_DOSSIER_DOWNLOADS';

export function requestAdditionalDossierDownloads(response) {
  return {
    type: ADDITIONAL_DOSSIER_DOWNLOADS_REQUESTED,
    additionalDossierDownloads: response
  }
}

export const handleRequestAdditionalDossierDownloads = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: REQUESTING_ADDITIONAL_DOSSIER_DOWNLOADS
      });

      const response = await apiPost('/v1/user/users/request_additional_dossier_downloads',
        {},
        session,
        cancelToken,
        {
          'Content-Type': 'multipart/form-data',
          'X-User-Email': session.email,
          'X-User-Token': session.token,
          'X-User-Admin-Log-Token': session.admin_auth_token,
        }
      )

      dispatch(requestAdditionalDossierDownloads(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_REQUESTING_ADDITIONAL_DOSSIER_DOWNLOADS,
        additionalDossierDownloads: {
          status: 'error',
          message: 'Error requesting additional downloads'
        }
      });
    }
  };
}

export const FETCHING_INTERCOM_APP_ID = 'FETCHING_INTERCOM_APP_ID';
export const INTERCOM_APP_ID_FETCHED = 'INTERCOM_APP_ID_FETCHED';
export const ERROR_FETCHING_INTERCOM_APP_ID = 'ERROR_FETCHING_INTERCOM_APP_ID';

export function fetchIntercomAppId(response) {
  return {
    type: INTERCOM_APP_ID_FETCHED,
    intercomAppId: response
  }
}

export const handleFetchIntercomAppId = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_INTERCOM_APP_ID
      });

      const response = await apiGet('/v1/user/users/intercom_app_id', session, {}, cancelToken);

      dispatch(fetchIntercomAppId(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_INTERCOM_APP_ID,
        intercomAppId: {
          status: 'error',
          message: 'Error fetching intercom token'
        }
      });
    }
  };
}

export const FETCHING_TOTANGO_SERVICE_DATA = 'FETCHING_TOTANGO_SERVICE_DATA';
export const TOTANGO_SERVICE_DATA_FETCHED = 'TOTANGO_SERVICE_DATA_FETCHED';
export const ERROR_FETCHING_TOTANGO_SERVICE_DATA = 'ERROR_FETCHING_TOTANGO_SERVICE_DATA';

export function fetchTotangoServiceData(response) {
  return {
    type: TOTANGO_SERVICE_DATA_FETCHED,
    totangoData: response
  }
}

export const handleFetchTotangoServiceData = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_TOTANGO_SERVICE_DATA
      });

      const response = await apiGet('/v1/user/users/totango_service_data', session, {}, cancelToken);

      dispatch(fetchTotangoServiceData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_TOTANGO_SERVICE_DATA,
        totangoData: {
          status: 'error',
          message: 'Error fetching totango service id'
        }
      });
    }
  };
}

export const REQUESTING_DOWNLOAD_LIST_ACCESS = 'REQUESTING_DOWNLOAD_LIST_ACCESS';
export const DOWNLOAD_LIST_ACCESS_REQUESTED = 'DOWNLOAD_LIST_ACCESS_REQUESTED';
export const ERROR_REQUESTING_DOWNLOAD_LIST_ACCESS = 'ERROR_REQUESTING_DOWNLOAD_LIST_ACCESS';

export function requestDownloadListAccess(response) {
  return {
    type: DOWNLOAD_LIST_ACCESS_REQUESTED,
    downloadListAccess: response
  }
}

export const handleRequestDownloadListAccess = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: REQUESTING_DOWNLOAD_LIST_ACCESS
      });

      const response = await apiPost('/v1/user/users/request_download_list_access',
        {},
        session,
        cancelToken,
        {
          'Content-Type': 'multipart/form-data',
          'X-User-Email': session.email,
          'X-User-Token': session.token,
          'X-User-Admin-Log-Token': session.admin_auth_token,
        }
      )

      dispatch(requestDownloadListAccess(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_REQUESTING_DOWNLOAD_LIST_ACCESS,
        downloadListAccess: {
          status: 'error',
          message: 'Error requesting additional downloads'
        }
      });
    }
  };
}

export const RESET_REQUESTING_DOWNLOAD_LIST_ACCESS = 'RESET_REQUESTING_DOWNLOAD_LIST_ACCESS';

export const handleResetDownloadListAccess = () => {
  return dispatch => {
    dispatch({
      type: RESET_REQUESTING_DOWNLOAD_LIST_ACCESS,
    })
  }
}

export const FETCHING_ADMIN_PERMISSION = 'FETCHING_ADMIN_PERMISSION';
export const ADMIN_PERMISSION_FETCHED = 'ADMIN_PERMISSION_FETCHED';
export const ERROR_FETCHING_ADMIN_PERMISSION = 'ERROR_FETCHING_ADMIN_PERMISSION';

export function fetchUserAdminPermission(response) {
  return {
    type: ADMIN_PERMISSION_FETCHED,
    userAdminPermission: response
  }
}

export const handleFetchUserAdminPermission = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_ADMIN_PERMISSION
      });

      const response = await apiGet('/v1/user/users/admin_permission', session, {}, cancelToken);

      dispatch(fetchUserAdminPermission(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_ADMIN_PERMISSION,
        userAdminPermission: {
          status: 'error',
          message: 'Error fetching user admin permission'
        }
      });
    }
  };
}